import { lazy } from "react";

export default {
  name: "Manage",
  path: "/manage",
  component: lazy(() => import("./index"))
}